import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import Notifications from 'vue-notification'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import VueMaterialIcon from 'vue-material-icon'
import VTooltip from 'v-tooltip'
import GlobalEvents from 'vue-global-events'
import VueMq from 'vue-mq'
import MobileDetect from "mobile-detect"
import VueWindowSize from 'vue-window-size'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAnDTefg8pqKnl6_k4LI4KlTr3lW4IixwE',
    //libraries: 'places' This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // // If you want to set the version, you can do so:
    // v: '3.26',
  }

  // // If you intend to programmatically custom event listener code
  // // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // // you might need to turn this on.
  // autobindAllEvents: false,

  // // If you want to manually install components, e.g.
  // // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // // Vue.component('GmapMarker', GmapMarker)
  // // then disable the following:
  // installComponents: true,

})
Vue.component('GmapCluster', GmapCluster)

Vue.component(VueMaterialIcon.name, VueMaterialIcon)

Vue.use(Notifications)

VTooltip.enabled = window.innerWidth > 768
Vue.use(VTooltip)

Vue.component('GlobalEvents', GlobalEvents)

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity,
  },
  defaultBreakpoint: 'sm' // customize this for SSR
})

Vue.use(VueWindowSize)

Vue.prototype.$isMobile = new MobileDetect(window.navigator.userAgent).phone() !== null

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
